import { IBookingCalendarPassengerDto } from "../dto/bookings/booking.dto";

export type FieldKey =
  | "code"
  | "phone"
  | "unit"
  | "area"
  | "active"
  | "eligible"
  | "passengerType"
  | "referent";

export const DEFAULT_FIELD_ORDER: readonly FieldKey[] = [
  "active",
  "code",
  "phone",
  "unit",
] as const;

export type FieldConfigType = {
  show: boolean;
  className: string;
  getValue: (
    passenger: IBookingCalendarPassengerDto | null,
  ) => string | undefined;
  excludeFromMapList?: boolean;
};
